import { Injectable } from '@angular/core';
import { StaticDataService } from '../service/static-data.service';
import { Config } from '../config/config';
import { Router } from '@angular/router';
import { RestDataService } from './rest-data.service';
import { forkJoin } from 'rxjs';
import {tap} from 'rxjs/operators/';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthenticationService {
    domains: any;
    domainId: any;
    constructor(
        public http: HttpClient,
        public config: Config,
        public router: Router,
        private restService: RestDataService
    ) { }

    headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      });
      options = {
        headers: this.headers
      }  

    login(jsondata: any, staySignedIn: boolean,loginType:string) {
        const Formbody = new URLSearchParams();
        Formbody.set('client_id', 'htcms');
        Formbody.set('grant_type', 'password');
        Formbody.set('username', jsondata.email);
        Formbody.set('password', jsondata.idToken);
        Formbody.set('client_secret', 'a9adf2da-0e02-4c89-a7a8-d211cffa289e');
        Formbody.set('flag', loginType);

        const oauth = this.http.post(
            this.config.getEndPoint(this.config.get('views'), 'login', 'oauth_token'),
            Formbody.toString(), this.options);
        const domainAll = this.http.get(this.config.get('product').domainUrl + '/api/public/domain/all', this.options);
        return forkJoin([oauth, domainAll]).pipe(tap(results => {
            let user = null;
            user = results[0];
            user['email'] = jsondata.email;
            user['name'] = user.user.name;
            localStorage.setItem('emailId', user.user['emailId']);
            // login successful if there's a jwt token in the response
            if (user.access_token !== null || user.access_token !== '') {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem(StaticDataService.tokenLiteral, JSON.stringify(user));
                this.domains = results[1];
                const idArr = [];
                Object.entries(user.user.domainPermissions).forEach(([key, value]) => {
                    idArr.push(key);
                });
                this.domains = this.domains.filter(obj => idArr.indexOf(obj['id']) !== -1);
                localStorage.setItem(StaticDataService.domains_all, JSON.stringify(this.domains));
                if (!sessionStorage.getItem(StaticDataService.domainLiteral) ||
                    sessionStorage.getItem(StaticDataService.domainLiteral) === undefined ||
                    sessionStorage.getItem(StaticDataService.domainLiteral) === 'undefined') {
                    sessionStorage.setItem(StaticDataService.domainLiteral, this.domains[0].id);
                    sessionStorage.setItem(StaticDataService.tenantName, this.domains[0].name);
                    localStorage.setItem(StaticDataService.timeLiteral, String(new Date().getTime()));
                }
                localStorage.setItem(StaticDataService.timeLiteral, String(new Date().getTime()));
            }
            return user;
        }));
    }


    refreshToken() {
        const token = localStorage.getItem(StaticDataService.tokenLiteral) ?
            JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))
            : null;
        // console.log(token);
        if (token) {
            const Formbody = new URLSearchParams();
            Formbody.set('client_id', 'htcms');
            Formbody.set('grant_type', 'refresh_token');
            Formbody.set('refresh_token', token['refresh_token']);
            Formbody.set('client_secret', 'a9adf2da-0e02-4c89-a7a8-d211cffa289e');

            const oauth = this.http.post(
                this.config.getEndPoint(this.config.get('views'), 'login', 'oauth_token'),
                Formbody.toString(), this.options);
            const domainAll = this.http.get(this.config.get('product').domainUrl + '/api/public/domain/all', this.options);
            return forkJoin([oauth, domainAll]).pipe(tap(results => {
                let user = null;
                user = results[0];
                user['email'] = token.email;
                user['name'] = token.name;
                if (user['access_token'] !== null || user['access_token'] !== '') {
                    localStorage.setItem(StaticDataService.tokenLiteral, JSON.stringify(user));
                    this.domainId = results[1];
                    const idArr = [];
                    Object.entries(user.user.domainPermissions).forEach(([key, value]) => {
                        idArr.push(key);
                    });
                    this.domainId = this.domainId.filter(obj => idArr.indexOf(obj['id']) !== -1);
                    localStorage.setItem(StaticDataService.domains_all, JSON.stringify(this.domainId));
                    if (!sessionStorage.getItem(StaticDataService.domainLiteral) ||
                        sessionStorage.getItem(StaticDataService.domainLiteral) === undefined ||
                        sessionStorage.getItem(StaticDataService.domainLiteral) === 'undefined') {
                        sessionStorage.setItem(StaticDataService.domainLiteral, this.domainId[0].id);
                    }
                    localStorage.setItem(StaticDataService.timeLiteral, String(new Date().getTime()));

                }
                return user;
            }));
        } else {
            console.log('couldn\'t find the token to refresh');
            return null;
        }
    }

    logout() {
        // remove user from local storage to log user out
        const token = localStorage.getItem(StaticDataService.tokenLiteral);
        if (token) {
            this.restService.http_get(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), 'login', 'logout'))
                .subscribe(data => {
                    console.log('data', data);
                },
                    err => {
                        console.log(err);
                    });
        }
        // localStorage.removeItem(StaticDataService.tokenLiteral);
        // localStorage.removeItem(StaticDataService.domains_all);
        // sessionStorage.removeItem(StaticDataService.domainLiteral);
        setTimeout(e => {
            localStorage.clear();
            sessionStorage.clear();
        }, 10);
        this.router.navigate(['/login']);
    }
}
